import { Checkbox, Label } from 'keep-react'

export const FormCheckbox = ({
  formik,
  name,
  label,
  prime,
}: {
  name: string
  label: string
  formik: any
  prime?: boolean
}) => {
  const { error, value } = formik.getFieldMeta(name)

  return (
    <div>
      <fieldset
        className={`flex items-center gap-2 ${prime ? '[&_button[data-state=checked]]:!bg-prime [&_button[data-state=checked]]:!border-prime [&_button[data-state=checked]]:hover:bg-black [&_button[data-state=checked]]:hover:text-white' : ''}`}
      >
        <Checkbox
          color="primary"
          defaultChecked={value ? true : false}
          id={name}
          name={name}
          onCheckedChange={() => formik.setFieldValue(name, !value)}
        />
        <Label className="text-body-4 block" htmlFor={name}>
          {label}
        </Label>
      </fieldset>

      {error && (
        <span className="py-2 block w-full text-body-5 text-error-600">
          {error}
        </span>
      )}
    </div>
  )
}
